export const clickOutside = (node) => {
  const handleOutsideComponent = (event) => {
    if (node && !node.contains(event.target) && !event.defaultPrevented) {
      node.dispatchEvent(new CustomEvent("click_outside", node))
    }
  }

  document.addEventListener("click", handleOutsideComponent, true)
  document.addEventListener("focusin", handleOutsideComponent, true)
  return {
    destroy() {
      document.removeEventListener("click", handleOutsideComponent, true)
      document.removeEventListener("focusin", handleOutsideComponent, true)
    },
  }
}
